export const latestUpdates = [
  {
    id: "u01",
    title: "机械心脏的低语",
    episode: "第 10 话 · 遗言协议",
    day: "今天",
    time: "20:00",
    genre: "科幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20cyberpunk%20girl%20with%20a%20glowing%20mechanical%20heart%2C%20neon%20warm%20amber%20and%20pink%20accents%2C%20clean%20dark%20background%2C%20sci%20fi%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-03&orientation=portrait",
    note: "本集公开了主角义体编号的来源，同时留下一条指向档案馆的线索。",
  },
  {
    id: "u02",
    title: "迷雾档案馆",
    episode: "第 11 话 · 空白的名字",
    day: "今天",
    time: "21:30",
    genre: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20librarian%20holding%20a%20lantern%20inside%20a%20misty%20endless%20archive%2C%20muted%20rose%20and%20teal%20green%20palette%2C%20clean%20mysterious%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-08&orientation=portrait",
    note: "第十一份卷宗出现后，管理员第一次在记录里看见了指向自己的词条。",
  },
  {
    id: "u03",
    title: "星尘旅者的黄昏",
    episode: "第 9 话 · 无声航行",
    day: "昨天",
    time: "19:30",
    genre: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20young%20traveler%20in%20a%20long%20coat%20standing%20on%20a%20cliff%20under%20a%20starry%20twilight%20sky%2C%20warm%20pink%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20detailed%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-01&orientation=portrait",
    note: "巡星船失去定位后，少女靠观测手记找到了一条不在图上的航线。",
  },
  {
    id: "u04",
    title: "剑与月的誓约",
    episode: "第 18 话 · 裂开的封印",
    day: "昨天",
    time: "22:00",
    genre: "战斗",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20swordswoman%20holding%20a%20glowing%20blade%20under%20a%20large%20moon%2C%20deep%20rose%20and%20gold%20palette%2C%20clean%20night%20background%2C%20epic%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-05&orientation=portrait",
    note: "月之巫女恢复了一段记忆，代价是两人之间的誓约出现第一道裂痕。",
  },
  {
    id: "u05",
    title: "银翼空战团",
    episode: "第 21 话 · 云上竞速",
    day: "2 天前",
    time: "18:00",
    genre: "科幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20female%20pilot%20in%20a%20futuristic%20aircraft%20above%20clouds%2C%20dynamic%20rose%20and%20amber%20palette%2C%20clean%20sky%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-14&orientation=portrait",
    note: "竞速赛中出现了未经登记的机体，队长必须在名次与队友安全之间取舍。",
  },
  {
    id: "u06",
    title: "逆风跑者",
    episode: "第 20 话 · 最后一棒",
    day: "2 天前",
    time: "20:30",
    genre: "运动",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20teenage%20runner%20sprinting%20on%20a%20track%20at%20sunset%2C%20energetic%20rose%20and%20amber%20palette%2C%20clean%20dynamic%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-07&orientation=portrait",
    note: "接力队临时调整棒次，少年第一次被安排在最不擅长的弯道位置。",
  },
  {
    id: "u07",
    title: "龙脊山脉的远征",
    episode: "第 22 话 · 地图之外",
    day: "3 天前",
    time: "21:00",
    genre: "冒险",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20an%20adventuring%20party%20crossing%20a%20dragon%20spine%20mountain%20range%2C%20heroic%20rose%20and%20amber%20palette%2C%20clean%20epic%20landscape%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-11&orientation=portrait",
    note: "远征队抵达标注终点，却发现地图边缘还有一条被刻意抹去的山道。",
  },
  {
    id: "u08",
    title: "无声侦探社",
    episode: "第 9 话 · 沉默的证人",
    day: "3 天前",
    time: "19:00",
    genre: "推理",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20calm%20detective%20in%20a%20quiet%20study%20with%20clues%20on%20a%20desk%2C%20muted%20rose%20and%20green%20palette%2C%20clean%20mystery%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-16&orientation=portrait",
    note: "唯一的目击者拒绝开口，侦探从一枚纽扣还原了整个夜晚。",
  },
  {
    id: "u09",
    title: "极夜列车",
    episode: "第 12 话 · 终点站",
    day: "4 天前",
    time: "22:30",
    genre: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20mysterious%20night%20train%20crossing%20a%20snowy%20polar%20landscape%2C%20moody%20rose%20and%20amber%20palette%2C%20clean%20cinematic%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-24&orientation=portrait",
    note: "列车首次在白昼停靠，乘客们意识到终点并非他们以为的那座城。",
  },
  {
    id: "u10",
    title: "时光邮局的来信",
    episode: "第 10 话 · 未寄出的信",
    day: "4 天前",
    time: "20:00",
    genre: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20girl%20delivering%20letters%20inside%20a%20clockwork%20post%20office%2C%20warm%20rose%20and%20gold%20palette%2C%20clean%20fantasy%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-12&orientation=portrait",
    note: "见习邮差发现有一封写给自己的信始终无法投递，日期停在三年前。",
  },
  {
    id: "u11",
    title: "海底两万里的信",
    episode: "第 5 话 · 灯塔之下",
    day: "5 天前",
    time: "18:30",
    genre: "冒险",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20girl%20in%20a%20submarine%20reading%20a%20letter%20surrounded%20by%20glowing%20fish%2C%20soft%20rose%20and%20aqua%20green%20palette%2C%20clean%20deep%20ocean%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-10&orientation=portrait",
    note: "深海邮差第一次收到回信，信封上盖着一枚早已停用的灯塔邮戳。",
  },
  {
    id: "u12",
    title: "星图占卜屋",
    episode: "第 11 话 · 逆行星辰",
    day: "5 天前",
    time: "21:30",
    genre: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20fortune%20teller%20reading%20a%20glowing%20star%20chart%20in%20a%20cozy%20shop%2C%20deep%20rose%20and%20gold%20palette%2C%20clean%20magical%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-19&orientation=portrait",
    note: "星图出现逆行轨迹，占卜师第一次无法看清明日的走向。",
  },
];